import { useNavigate } from 'react-router-dom';
import { AppBar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { MobileMenu } from '@/components/molecules/menu/mobile';
import { AppRouters } from '@/utils/constants/routers';
import { Toolbar, LeftItems, Logo, RightItems, LogoButton } from './styles';
import { Mobile } from '@/components/molecules/viewport/mobile';
import { IconButton } from '@/components/atoms/Button';
import { Close, Menu } from '@mui/icons-material';
import { useState } from 'react';

export const Navbar = () => {
  const theme = useTheme();

  const navigate = useNavigate();

  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  const iconColor = theme.palette.action.active;

  const handleToggleMenu = () => {
    setOpenMobileMenu(!openMobileMenu);
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{
          zIndex: 9999,
          boxShadow: 'none',
          background: 'transparent',
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Toolbar>
          <LeftItems>
            <Mobile>
              <LogoButton onClick={() => navigate(AppRouters.home)}>
                <Logo src="/img/png/logos/logo_kyt.png" alt="logo" />
              </LogoButton>
            </Mobile>
          </LeftItems>

          <Mobile>
            <RightItems>
              <IconButton onClick={handleToggleMenu}>
                {openMobileMenu ? (
                  <Close sx={{ color: iconColor }} />
                ) : (
                  <Menu sx={{ color: iconColor }} />
                )}
              </IconButton>
            </RightItems>
          </Mobile>
        </Toolbar>
      </AppBar>

      {openMobileMenu && (
        <Mobile>
          <MobileMenu />
        </Mobile>
      )}
    </>
  );
};
